// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@awc/XDL/types";

export default {
    primary: {
        main: "#002169",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#EE7623",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#CCCCCC",
        disabled: "#F2F2F2",
        // XNG-Changes
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#CCCCCC",
        ui4: "#999999",
        ui5: "#666666",
        ui6: "#252525",
        ui7: "#000000",
        ui8: "#00578F",
        ui9: "#001647",
        ui10: "#FF954B",
        ui11: "#A75217",
        ui12: "#0068FF",
        ui13: "#F4C653",
        ui14: "#E56325",
        ui15: "#E5EEF4",
        ui16: "#F2F2F2",
        white: "#FFFFFF",
        black: "#000000",
        ui17: "#D7D7D7",
        ui18: "#fcf4f2",
        ui19: "#f9c9bf",
        ui20: "#f1f1f1",
        ui21: "#636363",
        ui22: "#F5F5F5",
        ui23: "#4d4d4d",
        ui24: "#f6f6f6",
        ui25: "#b8b8b8",
        ui26: "#e0e0e0",
        ui27: "#e0e7ea",
        ui28: "#D6561A",
        ui29: "#929292",
        ui30: "#808080",
        ui31: "#dddddd",
        ui32: "#acacac",
    },
    text: {
        main: "#252525",
        disabled: "#475353",
        accent: "#FF0000",
        link: "#002169",
    },
    success: {
        main: "#00A65A",
        light: "#D9F2E7",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#C60F13",
        light: "#FBDBE5",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#DAA91C",
        light: "#FDF9DE",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#53ACDB",
        light: "#DDEEF8",
        contrast: "#FFFFFF",
    },
} as xBaseTheme["colors"];
